import React from "react";
import styles from "./layout.module.scss";
import classnames from "classnames";

interface Props {
  children: React.ReactNode;
  vars?: React.CSSProperties;
  className?: string;
  style?: React.CSSProperties;
}

const LayoutGrid = (props: Props) => {
  const { children, vars, className, style } = props;
  const classes = classnames(styles.layoutGrid, className);
  return (
    <div className={classes} style={{ ...vars, ...style }}>
      {children}
    </div>
  );
};

export default LayoutGrid;
